import React from 'react';
import PropTypes from 'prop-types';

import { Select } from 'components/ui/select';

import Menu from './menu';
import Option from './option';
import { searchContacts } from 'bundles/backoffice/contacts/api';

export default class ContactSelect extends React.Component {
  static propTypes = {
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    contact: PropTypes.shape({
      displayName: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired
    }),
    disabled: PropTypes.bool,
    iconClassName: PropTypes.string,
    limitToType: PropTypes.oneOf(['business', 'person']),
    menuPlacement: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    // TODO: Support empty states without creation and make this optional
    onCreateClick: PropTypes.func.isRequired
  }

  get contactTypeLabel() {
    return this.props.limitToType === 'business' ? 'company' : 'contact';
  }

  get contactTypeLabelPlural() {
    return this.props.limitToType === 'business' ? 'companies' : 'contacts';
  }

  searchContacts = (query, callback) => {
    const params = { query };

    if (this.props.limitToType) {
      params.type = this.props.limitToType;
    }

    searchContacts(params, callback);
  }

  render() {
    return (
      <Select
        aria-label="search"
        autoFocus={this.props.autoFocus}
        className={this.props.className}
        components={{ Menu, Option }}
        contactTypeLabel={this.contactTypeLabel}
        contactTypeLabelPlural={this.contactTypeLabelPlural}
        getOptionLabel={contact => contact.displayName}
        getOptionValue={contact => contact.id}
        isClearable
        isDisabled={this.props.disabled}
        loadOptions={this.searchContacts}
        menuPlacement={this.props.menuPlacement}
        placeholder={`Enter ${this.contactTypeLabel} name or email`}
        value={this.props.contact}
        onChange={this.props.onChange}
        onCreateClick={this.props.onCreateClick}
      />
    );
  }
}
